import { render, staticRenderFns } from "./publication_trait.vue?vue&type=template&id=1538d388&scoped=true&"
import script from "./publication_trait.vue?vue&type=script&lang=js&"
export * from "./publication_trait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1538d388",
  null
  
)

export default component.exports